import type { NitroFetchOptions } from 'nitropack'
import type { KftApiDefaultResponse } from '~/composables/types/kft-api'

export function kftApiRequest<T, M = unknown, W = KftApiDefaultResponse<T, M>>(
  url: string,
  options: NitroFetchOptions<
    any,
    | 'post'
    | 'get'
    | 'head'
    | 'patch'
    | 'put'
    | 'delete'
    | 'connect'
    | 'options'
    | 'trace'
  > = {}
) {
  const config = useRuntimeConfig()
  const { apiBaseURL } = config.public

  const { $i18n: i18n } = useNuxtApp()
  const { locale: ISOLocale } = i18n
  const locale = convertISO2Locale(ISOLocale.value)
  const localeBCP47 = convertLocaleIntoBCP47(ISOLocale.value)

  let key = url
  if (key[0] === '/') {
    // remove the leading slash so that google does not crawl unwanted urls
    key = key.slice(1)
  }

  const defaultOptions = {
    baseURL: apiBaseURL,
    method: 'POST' as const,
    // cache request
    key,
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': `${localeBCP47},${locale}`,
    },
  }

  if (options.headers) {
    options.headers = {
      ...defaultOptions.headers,
      ...options.headers,
    }
  }

  const fetchOptions = { ...defaultOptions, ...options }

  return $fetch<W>(url, fetchOptions)
}
